import { ASSIGN_VEHICLE,
        REJECT_VEHICLE_REQUEST,
        FETCH_WORKER_DETAILS,
        ASSIGN_VEHICLE_IST,
        REJECT_VEHICLE_REQUEST_IST,
        ACCEPT_INDENT_WITHOUT_ASSIGN,
        ACCEPT_INDENT_IST_WITHOUT_ASSIGN,
        PRINT_FLM_LORRY_RECEIPT } from 'src/api/routes';
import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';

const { API_BASE_URL } = config;

export const assignVehicle = async (body) => {
  return POST(`${API_BASE_URL}${ASSIGN_VEHICLE}`, body);
};

export const assignVehicleIST = async (body) => {
  return POST(`${API_BASE_URL}${ASSIGN_VEHICLE_IST}`, body);
};

export const rejectVehicleRequest = async (body) => {
  return POST(`${API_BASE_URL}${REJECT_VEHICLE_REQUEST}`, body);
};

export const rejectVehicleRequestIST = async (body) => {
  return POST(`${API_BASE_URL}${REJECT_VEHICLE_REQUEST_IST}`, body);
};

export const fetchWorkerInfo = async (body) => {
  return POST(`${API_BASE_URL}${FETCH_WORKER_DETAILS}`, body);
};

export const acceptIndentWithoutAssign = async (body) => {
  return POST(`${API_BASE_URL}${ACCEPT_INDENT_WITHOUT_ASSIGN}`, body);
};

export const acceptIndentISTtWithoutAssign = async (body) => {
  return POST(`${API_BASE_URL}${ACCEPT_INDENT_IST_WITHOUT_ASSIGN}`, body);
};

export const printFLMLorryReceipt = async (tripId) => {
  return GET(`${API_BASE_URL}${PRINT_FLM_LORRY_RECEIPT}`, { trip_id: tripId }, 'blob');
};
